// extracted by mini-css-extract-plugin
export default {"capsuleTab":"styles_capsuleTab__K8jZD"};